import React from 'react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { useUnassignedProductsCountQuery } from '@/entities/assortment'

import { Operators } from '@/shared/components/query-builder'
import { Badge } from '@/shared/components/ui/badge'
import { Spinner } from '@/shared/components/ui/spinner'
import { formatNumber } from '@/shared/tools/locale'
import { getFiltersQueryObject } from '@/shared/tools/location'

export function UassigneProductsBage() {
	const { t } = useTranslation()

	const { isLoading, data, isRefetching } = useUnassignedProductsCountQuery()

	return (
		!!data && (
			<div className='flex items-center'>
				<Badge
					variant='warning'
					className='text-nowrap no-underline'
					interactive
					asChild
				>
					<Link
						to='/p/products'
						search={getFiltersQueryObject([
							{
								name: 'pricing_campaign_id',
								operation: Operators.IS_EMPTY as const,
								value: '1',
							},
						])}
					>
						<div className='flex items-center space-x-2'>
							{isLoading || isRefetching ? (
								<Spinner />
							) : (
								<strong className='fade-in'>{formatNumber(data!)}</strong>
							)}
							<span>{t('unassigned_item_not_to_repricing')} </span>
						</div>
					</Link>
				</Badge>
			</div>
		)
	)
}
export default UassigneProductsBage
